import * as React from "react";

import { UploadComment } from "../utils/ServiceManagerAPI";
import "../main.css";

const CommentUpload = ({ questionId, questionnaireId, done }: { questionId: string; questionnaireId: string; done: Function }) => {
  const [commentText, setCommentText] = React.useState("");
  const [isLoaded, setIsLoaded] = React.useState(false);

  const uploadComment = () => {
    UploadComment({
      text: commentText,
      questionId: questionId,
      questionnaireId: questionnaireId,
    }).then((res) => {
      done(res);
    });
  };

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col gap-1">
        <textarea 
          autoFocus={true} 
          value={commentText} 
          onChange={(e) => setCommentText(e.target.value)}
          className="border border-gray-300 dark:border-gray-600 rounded px-3 py-2 w-full text-gray-900 dark:text-gray-100 bg-white dark:bg-gray-800 resize-none min-h-[100px]"
          placeholder="Enter your comment..."
        />
        {!commentText && <span className="text-sm text-red-500">Comment Empty</span>}
      </div>
      <button 
        className="px-4 py-2 rounded bg-brand text-white hover:bg-brand-dark transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        disabled={!commentText} 
        onClick={uploadComment}
      >
        Save
      </button>
    </div>
  );
};
export default CommentUpload;
